<mat-card class="form-card">
  <mat-tab-group
    *ngIf="variants && recipeOriginal && yieldUnits"
    (selectedTabChange)="tabChange($event)"
    [selectedIndex]="getSelectedIndex()"
  >
    <mat-tab *ngFor="let variant of sortedVariants" #tab [disabled]="variantDirty | async">
      <ng-template mat-tab-label>
        <span
          id="RecipesModifyVariantNbrLbl"
          class="space-h-l"
          [matTooltipDisabled]="tab.isActive"
          matTooltip="ID: {{ variant.identifier.functionalId }}"
          matTooltipClass="tooltip-main"
        >
          {{ getTabLabel(variant) }}
          <ng-container *ngIf="variant.isAutomaticallyGenerated"> ({{ 'VARIANTS.AUTO' | translate }}) </ng-container>
        </span>
        <mat-chip class="whiteBackground" *ngIf="tab.isActive" disableRipple [disabled]="variantDirty | async"
          ><span id="RecipesModifyVariantIdLbl">ID : {{ variant.identifier.functionalId }}</span></mat-chip
        >
      </ng-template>
      <ng-template matTabContent>
        <app-variant-tab
          [variant]="variantDetails$[variant.identifier.functionalId] | async"
          [statusesRefData]="statusesRefData"
          [yieldUnits]="yieldUnits"
          [marketingFoods]="(marketingFoods$ | async) || []"
          [applianceGroupsRefData]="applianceGroupsRefData"
          [utensilsRefData]="utensilsRefData"
          (variantModified)="variantDirty.emit($event)"
          (updateVariant)="updateVariant($event)"
          (variantDeleted)="variantDeleted()"
        ></app-variant-tab>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="variantDirty | async">
      <ng-template mat-tab-label>
        <span class="space-h-l">{{ 'VARIANTS.ADD' | translate }}</span>
        <i id="RecipesModifyVariantAddBtn" class="fas fa-plus" aria-hidden="true"></i>
      </ng-template>
      <ng-template matTabContent>
        <app-new-variant-tab
          [existingVariants]="variantsIdAndLabels"
          [creationStatus]="statusesRefData?.DRAFT"
          [selectedYieldUnit]="yieldUnits[recipeOriginal.yield.unit]"
          [yieldUnitsList]="yieldUnits"
          [variantDomain]="recipeOriginal.domain"
          [variantMarket]="recipeOriginal.market"
          [variantLang]="recipeOriginal.lang"
          (newVariantCreated)="newVariant($event)"
        ></app-new-variant-tab>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-card>
